import type { BaseHttpRequest } from '@/api/generated-client/core/BaseHttpRequest';
import { GetUserBlockSettingParameters } from '@/api/models/get-user-block-setting-parameters';
import { CommentsBlockSettingDto } from '@/api/models/comments-block-setting.dto';
import { UpdateUserBlockSettingParameters } from '@/api/models/update-user-block-setting-parameters';
import { BaseApi } from '@/api/base-api';

export class UserBlockApi extends BaseApi {
  constructor(public readonly httpRequest: BaseHttpRequest) {
    super();
  }

  private controller = '/catalog/comments';

  getUserBlockSetting({ userId }: GetUserBlockSettingParameters): Promise<CommentsBlockSettingDto> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[GET] /api/v1/game-comments/management/user-block?userId=${userId}`,
      {}
    );
  }

  updateUserBlockSetting(
    { userId }: UpdateUserBlockSettingParameters,
    data: CommentsBlockSettingDto,
  ): Promise<void> {
    return this.httpRequest.rpcRequest(
      this.controller,
      `[PUT] /api/v1/game-comments/management/user-block?userId=${userId}`,
      data as any,
    );
  }
}
